/**
 * This file was auto-generated by Fern from our API Definition.
 */
import { RestoreOptions } from "../types/RestoreOptions";
export const Request = RestoreOptions.optional();
